import React from "react";

export const Header = () => {
  return (
    <header id="masthead" class="site-header responsive-max-width">
      <div class="site-branding">
        <div class="site-logo">
          <a
            href="https://panchalharit.wordpress.com/"
            class="custom-logo-link"
            rel="home"
            aria-current="page"
          >
            <img
              width="401"
              height="223"
              src="https://panchalharit.files.wordpress.com/2022/03/cropped-mylogo.png"
              class="custom-logo"
              alt="Harit Panchal"
              decoding="async"
              srcset="https://panchalharit.files.wordpress.com/2022/03/cropped-mylogo.png 401w, https://panchalharit.files.wordpress.com/2022/03/cropped-mylogo.png?w=150&amp;h=83 150w, https://panchalharit.files.wordpress.com/2022/03/cropped-mylogo.png?w=300&amp;h=167 300w"
              sizes="(max-width: 401px) 100vw, 401px"
              data-attachment-id="170"
              data-permalink="https://panchalharit.wordpress.com/cropped-mylogo-png/"
              data-orig-file="https://panchalharit.files.wordpress.com/2022/03/cropped-mylogo.png"
              data-orig-size="401,223"
              data-comments-opened="1"
              data-image-meta='{"aperture":"0","credit":"","camera":"","caption":"","created_timestamp":"0","copyright":"","focal_length":"0","iso":"0","shutter_speed":"0","title":"","orientation":"0"}'
              data-image-title="cropped-mylogo.png"
              data-image-description="<p>https://panchalharit.files.wordpress.com/2022/03/cropped-mylogo.png</p>"
              data-image-caption=""
              data-medium-file="https://panchalharit.files.wordpress.com/2022/03/cropped-mylogo.png?w=300"
              data-large-file="https://panchalharit.files.wordpress.com/2022/03/cropped-mylogo.png?w=401"
            />
          </a>
        </div>
      
      </div>
      <nav
        id="site-navigation"
        class="main-navigation"
        aria-label="Main Navigation"
      >
      
     
        <div class="menu-main-container">
          <ul id="menu-main" class="main-menu" aria-label="submenu">
            <li
              id="menu-item-229"
              class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-107 current_page_item menu-item-229"
            >
              {/* <a href="https://panchalharit.wordpress.com/" aria-current="page">
                Home
              </a> */}
            </li>
            {/* <li
              id="menu-item-230"
              class="menu-item menu-item-type-post_type menu-item-object-page menu-item-230"
            >
              <a href="https://panchalharit.wordpress.com/about/">About</a>
            </li> */}
            {/* <li
              id="menu-item-233"
              class="menu-item menu-item-type-custom menu-item-object-custom menu-item-233"
            >
              <a href="mailto:panchalharit007@gmail.com">Contact</a>
            </li> */}
          </ul>
        </div>{" "}
      </nav>
    </header>
  );
};
